// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"35553cdb","885":"0bc84134"}[chunkId] + ".chunk.js";
};